import { browserHistory } from 'react-router';

/**
 * Redirect utility for redirecting to a page and storing the return path.
 * Uses a singleton pattern to manage return path state.
 */

class RedirectManager {
  private static instance: RedirectManager;
  private returnPath: string | null = null;

  private constructor() {}

  public static getInstance(): RedirectManager {
    if (!RedirectManager.instance) {
      RedirectManager.instance = new RedirectManager();
    }
    return RedirectManager.instance;
  }

  /**
   * Stores the return destination path.
   */
  public setReturnPath(path: string): void {
    this.returnPath = path;
  }

  /**
   * Retrieves and clears the return destination path.
   */
  public getAndClearReturnPath(): string | null {
    const path = this.returnPath;
    this.returnPath = null;
    return path;
  }

  /**
   * Clears any stored return path.
   */
  public clearReturnPath(): void {
    this.returnPath = null;
  }

  /**
   * Redirects to the specified page and stores the current path as the return destination.
   */
  public redirectAndStoreReturnPath(page: string, currentPath?: string): void {
    const pathToStore =
      currentPath ||
      window.location.pathname + window.location.search + window.location.hash;
    if (pathToStore !== page) {
      this.setReturnPath(pathToStore);
    }
    browserHistory.push(page);
  }

  /**
   * Reset instance
   */
  public static resetInstance(): void {
    if (RedirectManager.instance) {
      RedirectManager.instance.clearReturnPath();
    }
  }
}

// Export convenience functions
const manager = RedirectManager.getInstance();

export function getAndClearReturnPath(): string | null {
  return manager.getAndClearReturnPath();
}

export function redirectAndStoreReturnPath(
  page: string,
  currentPath?: string
): void {
  manager.redirectAndStoreReturnPath(page, currentPath);
}

// Export the manager class for testing purposes
export { RedirectManager };
